import { KeyValue } from '@angular/common';
import { Component, Input, Injectable, ViewEncapsulation } from '@angular/core';
import { Attribute } from 'src/app/shared/models/attributes/attribute';
import { FlatAttribute } from 'src/app/shared/models/attributes/flatAttribute';

@Component({
  selector: 'person-form-details',
  templateUrl: 'person-form-details.component.html',
  styleUrls: ['person-form-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
@Injectable()
export class PersonFormDetailsComponent {
  private allAttributes: Attribute[];
  flatAttributes: FlatAttribute[];

  @Input()
  noValueText: string = '';
  @Input()
  useDescription: boolean = false;

  @Input()
  set attributes(value: Attribute[]) {
    this.allAttributes = value;
    this.prepareFlatValueModel();
  }
  get attributes() {
    return this.allAttributes;
  }

  @Input()
  systemFields: KeyValue<string, string>[];

  constructor() {}

  prepareFlatValueModel() {
    this.flatAttributes = FlatAttribute.fromAttributes(this.allAttributes);
  }
}
